<template>
  <div class="workflow-wrapper">
    <control-panel key="control-panel"></control-panel>
    <workarea key="workarea"></workarea>
    <config-panel key="config-panel"></config-panel>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import ControlPanel from './view-relations-section-control-panel.vue';
  import Workarea from './view-relations-section-workarea.vue';
  import ConfigPanel from './view-relations-section-config-panel.vue';
  import cTooltip from '~/modules/cTooltip/reload';

  export default Vue.extend({
    components: {
      ControlPanel,
      ConfigPanel,
      Workarea,
    },
    mixins: [cTooltip],
  });
</script>